import React, { useState, useEffect, useMemo } from 'react'
import Breadcrumb from '../../../components/partials/Breadcrumb';
import { BiCategory } from "react-icons/bi";
import { Alerts, GetPost } from '../../../helpers';
import MUIDataTable from "mui-datatables";
import { Link } from 'react-router-dom';
import { FaEdit, FaTimes, FaPlus } from "react-icons/fa";
import ConfirmationDialog from '../../../components/cmp/ConfirmationDialog';
import { TbAntennaBars1 } from "react-icons/tb";
import { IoAddCircleOutline } from "react-icons/io5";
import ThemeModal from '../../../components/cmp/ThemeModal';
import { GetSettings } from '../../../helpers';
import { Formik } from 'formik';
import * as Yup from "yup";
import Select from "react-select";
import ReactCountryFlag from "react-country-flag"
import AddRateForm from './AddRateForm';
import parse from 'html-react-parser';
import { Tab, Tabs } from 'react-bootstrap';
import ExistingShippingZoneRates from './ExistingShippingZoneRates';
import Dropdown from 'react-bootstrap/Dropdown';

import countryList from "react-select-country-list";
import { State } from "country-state-city";


import EditShippingZone from './EditShippingZone';
import ConfModal from '../../../components/cmp/ConfModal';


const breadcrumbs = [
    {
        id: 1,
        label: "Dashboard",
        link: "/",
    },
    {
        id: 2,
        label: "Categories",
        link: "/app/product/categories",
    },
];

const ShippingZones = () => {
    const [isLoading, setLoading] = useState(true);
    const [isAddZone, setAddZone] = useState(false);
    const [isAddRate, setAddRate] = useState(false);
    const [shippingCountries, setShippingCountries] = useState([]);
    const [shippingZones, setShippingZones] = useState([]);
    const [currentZone, setCurrentZone] = useState(null);
    const [states, setStates] = useState([]);

    //edit
    const [isEditZone, setEditZone] = useState(false);
    const [editZone, setZone] = useState(null);



    const [selectAllStates, setSelectAllStates] = useState(false);

    const options = useMemo(() => countryList().getData(), []);

    const handleOpenRateZone = (zoneItem) => {
        setCurrentZone(zoneItem);
        setAddRate(true);
    }

    const handleCloseRateZone = () => {
        setCurrentZone(null);
        setAddRate(false);
    }

    const handleOpenAdd = () => {
        setAddZone(true);
    }
    const handleCloseAdd = () => {
        setAddZone(false);
    }


    const handleOpenEdit = (zone_id) => {
        const fShippingZone = shippingZones.find(el => el.id === parseInt(zone_id));
        if (fShippingZone) {
            setZone(fShippingZone);
            setEditZone(true);
        }
    }

    const handleCloseEdit = () => {
        setZone(null);
        setEditZone(false);
    }

    const getShippingCountries = async () => {
        const resp = await GetSettings.getShippingZoneCountries();
        if (resp && resp.status) {

            if (resp.shipping_countries && resp.shipping_countries.length > 0) {
                const countries = resp.shipping_countries.map(country => ({
                    value: country.id,
                    label: country.country_name
                }));
                setShippingCountries(countries);
            }
            setLoading(false);
        }
    }

    const getShippingZone = async () => {
        const resp = await GetSettings.getShippingZones();
        if (resp && resp.status) {
            setShippingZones(resp.shipping_zones);
            console.log(resp);
        }
    }

    useEffect(() => {
        getShippingCountries();
        getShippingZone();
    }, []);


    const validationSchema = Yup.object().shape({
        country_code: Yup.string().required('Country is required'),
        states: Yup.array()
            .of(
                Yup.object().shape({
                    value: Yup.string().required(),
                    label: Yup.string().required(),
                })
            )
            .min(1, 'At least one state is required'),
    });


    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        const resp = await GetSettings.createShippingZone(values);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            setSubmitting(false);
            resetForm();
            getShippingZone();
            handleCloseAdd();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
            setSubmitting(false);
        }
    }

    const handleCountryChange = (option, setFieldValue) => {
        const countryCode = option ? option.value : '';
        const countryName = option ? option.label : '';

        setFieldValue('country_code', countryCode);
        setFieldValue('country_name', countryName);

        if (countryCode) {
            const statesData = State.getStatesOfCountry(countryCode);
            const newStatesOptions = statesData.map((s) => ({
                value: s.isoCode,
                label: s.name,
            }));
            setStates(newStatesOptions);
            setSelectAllStates(true);
            setFieldValue('states', newStatesOptions);
        } else {
            setStates([]);
            setSelectAllStates(false);
            setFieldValue('states', []);
        }
    };


    const handleStateChange = (selectedOptions, setFieldValue) => {
        setFieldValue('states', selectedOptions || []);
        setSelectAllStates(false);
    };

    const handleCheckboxChange = (e, setFieldValue) => {
        const isChecked = e.target.checked;
        setSelectAllStates(isChecked);
        setFieldValue('states', isChecked ? states : []);
    };


    const handleDeleteZone = async (delId) => {
        const resp = await GetSettings.deleteShippingZone(delId);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            getShippingZone();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }


    
    const handleDeleteRate = async (delId) => {
        const resp = await GetSettings.deleteShippingZoneRate(delId);
        if (resp && resp.status) {
            Alerts.alertMessage(resp.message, 'top-right', 'success');
            getShippingZone();
        } else {
            Alerts.alertMessage(resp.message, 'top-right', 'error');
        }
    }

    return (
        <>
            <Breadcrumb breadcrumbs={breadcrumbs} />
            <div className="innerPageWrapper">
                <div className='container-fluid'>
                    <div className='page-title'>
                        <h2><BiCategory /> Shipping Zones</h2>
                        <button onClick={handleOpenAdd} className="btn btn-success"><FaPlus />Add shipping zones</button>
                    </div>
                    {
                        isLoading ? <div className='loader'>
                            <img src='/images/loader.gif' alt='loader' />
                        </div> : <>
                            <div className='shipping-zone-list'>
                                {
                                    shippingZones && shippingZones.length > 0 ?
                                        shippingZones.map((zoneItems, i) => {
                                            return <div key={zoneItems.id} className='shipping-zone-items'>
                                                <div className='d-flex align-items-center justify-content-between'>
                                                    <div className='country-details'>
                                                        <ReactCountryFlag
                                                            countryCode={zoneItems.country_code}
                                                            svg
                                                            cdnUrl="https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/1x1/"
                                                            style={{
                                                                fontSize: '1.5em',
                                                            }}
                                                        />
                                                        <span>{zoneItems.country_name} - {zoneItems.country_name}</span>
                                                    </div>


                                                    <Dropdown>
                                                        <Dropdown.Toggle className="dropdown-toogle btn-icon">
                                                            <TbAntennaBars1 />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu className='dropdown-list'>

                                                            <Dropdown.Item as="button" className="dropdown-btn" onClick={() => handleOpenEdit(zoneItems.id)}>
                                                                View / Edit
                                                            </Dropdown.Item>
                                                            <ConfModal delId={zoneItems.id} handleDelete={handleDeleteZone} isIcon={false} message={'Are you sure you want to delete this zone !'} />
                                                        </Dropdown.Menu>
                                                    </Dropdown>

                                                </div>
                                                <div className='rate-details2'>
                                                    {
                                                        zoneItems.shipping_zone_rates && zoneItems.shipping_zone_rates.length > 0 ? <>
                                                            {
                                                                zoneItems.shipping_zone_rates.map((zone_rate) => {
                                                                    return <div key={zone_rate.id} className="preview-box-inner border rounded bg-gray-100" style={{ padding: '15px 15px' }}>
                                                                        <div>

                                                                            <div>{parse(zone_rate.shipping_rate.shipping_rate_label.preview_label)}</div>
                                                                            {zone_rate.shipping_rate.shipping_rate_type === "price" ? `Price Range - (£${zone_rate.shipping_rate.min_price} - £${zone_rate.shipping_rate.max_price})` : null}
                                                                            {zone_rate.shipping_rate.shipping_rate_type === "weight" ? `Weight Range - (${zone_rate.shipping_rate.min_weight}kg - ${zone_rate.shipping_rate.max_weight}kg)` : null}
                                                                        </div>
                                                                        <div>
                                                                            <div className="price-tag">{parseFloat(zone_rate.shipping_rate.price) > 0 ? <div className='shipping-price'>£ ${zone_rate.shipping_rate.price}</div> : <span>Free</span>}</div>
                                                                            <Dropdown>
                                                                                <Dropdown.Toggle className="dropdown-toogle btn-icon">
                                                                                    <TbAntennaBars1 />
                                                                                </Dropdown.Toggle>

                                                                                <Dropdown.Menu className='dropdown-list'>
                                                                                    <ConfModal delId={zone_rate.id} handleDelete={handleDeleteRate} isIcon={false} message={'Are you sure you want to remove this!'} />
                                                                                </Dropdown.Menu>
                                                                            </Dropdown>
                                                                        </div>

                                                                    </div>
                                                                })
                                                            }
                                                        </> : <p className='rate-not-found'>Rate not added !</p>
                                                    }
                                                </div>
                                                <div className='add-rate'>
                                                    <button className='btn btn-default btn-sm' onClick={() => handleOpenRateZone(zoneItems)}><IoAddCircleOutline /> Add Rate</button>


                                                </div>
                                            </div>
                                        }) : <div style={{ width: '100%', minHeight: 250, textAlign: 'center', padding: '50px 20px' }}><p>Shipping zone not added !</p></div>
                                }
                            </div>


                            {
                                editZone && <EditShippingZone show={isEditZone} handleHide={handleCloseEdit} zoneDetails={editZone} getShippingZone={getShippingZone} />
                            }


                            <ThemeModal show={isAddZone} handleHide={handleCloseAdd} title={'Add Shipping Zone'}>
                                <Formik
                                    initialValues={{
                                        country_code: "",
                                        country_name: "",
                                        states: []
                                    }}
                                    validationSchema={validationSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({
                                        values,
                                        errors,
                                        touched,
                                        handleBlur,
                                        handleSubmit,
                                        isSubmitting,
                                        setFieldValue,
                                    }) => (
                                        <form onSubmit={handleSubmit}>

                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label>Select Country</label>
                                                        <Select
                                                            options={options}
                                                            value={
                                                                values.country_code
                                                                    ? { value: values.country_code, label: values.country_name }
                                                                    : null
                                                            }
                                                            onChange={(option) => handleCountryChange(option, setFieldValue)}
                                                            onBlur={handleBlur}
                                                            name="country_code"
                                                            placeholder="Select a country"
                                                        />
                                                        {errors.country_code && touched.country_code && (
                                                            <div className="text-danger">{errors.country_code}</div>
                                                        )}
                                                    </div>

                                                    {values.country_code && states.length > 0 && (
                                                        <div className="form-group form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input auto-h"
                                                                id="selectAllStates"
                                                                checked={selectAllStates}
                                                                onChange={(e) => handleCheckboxChange(e, setFieldValue)}
                                                            />
                                                            <label className="form-check-label" htmlFor="selectAllStates">
                                                                Select All States
                                                            </label>
                                                        </div>
                                                    )}

                                                    {
                                                        !selectAllStates && values.country_code !== '' && <div className="form-group">
                                                            <label>State / Region</label>
                                                            <Select
                                                                options={states}
                                                                isMulti
                                                                value={values.states}
                                                                onChange={(options) => handleStateChange(options, setFieldValue)}
                                                                onBlur={handleBlur}
                                                                name="states"
                                                                placeholder="Select state(s) / region(s)"
                                                                isDisabled={!values.country_code}
                                                                isClearable
                                                                closeMenuOnSelect={false}
                                                            />
                                                            {errors.states && touched.states && (
                                                                <div className="text-danger">{errors.states}</div>
                                                            )}
                                                            {values.states && values.states.length > 0 && (
                                                                <small className="text-muted">
                                                                    Selected: {values.states.length} state(s)
                                                                </small>
                                                            )}
                                                        </div>
                                                    }

                                                    <div className="text-center">
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary btn-block"
                                                            disabled={isSubmitting || !values.country_code}
                                                            style={{
                                                                width: "100%",
                                                                maxWidth: "150px",
                                                            }}
                                                        >
                                                            {isSubmitting ? "Submitting..." : "Submit"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                </Formik>
                            </ThemeModal>

                            {currentZone !== null && <ThemeModal show={isAddRate} handleHide={handleCloseRateZone} title={'Add Shipping Rate'}>
                                <Tabs
                                    defaultActiveKey="new"
                                    id="uncontrolled-tab-example"
                                    className="mb-3"
                                >
                                    <Tab eventKey="new" title="Add New Rate">
                                        <AddRateForm shipping_zone={currentZone} handleCloseRateZone={handleCloseRateZone} getShippingZone={getShippingZone} />
                                    </Tab>
                                    <Tab eventKey="existing" title="Existing Rates">
                                        <ExistingShippingZoneRates shipping_zone={currentZone} handleCloseRateZone={handleCloseRateZone} getShippingZone={getShippingZone} />
                                    </Tab>

                                </Tabs>

                            </ThemeModal>}
                        </>
                    }

                </div>
            </div>
        </>
    )
}

export default ShippingZones;